<template>
  <div>
    <Pane v-if="!inModal" />
    <a-card v-if="!inModal" class="container">
      <Padding/>

      <a-table
          bordered
          :columns="columns"
          :dataSource="list"
          :loading="loading"
          @change="onChange"
          :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <template slot="statusCol" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusName(text) }}</a-tag>
        </template>
        <template slot="actionCol" slot-scope="text, record">
          <a-space>
            <a href="#" @click.prevent="$emit('detail', record)">详情</a>
          </a-space>
        </template>
      </a-table>
    </a-card>
    <template v-else>
      <a-table
        bordered
        :columns="columns"
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <template slot="statusCol" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusName(text) }}</a-tag>
        </template>
        <template slot="actionCol" slot-scope="text, record">
          <a-space>
            <a href="#" @click.prevent="$emit('detail', record)">详情</a>
          </a-space>
        </template>
      </a-table>
    </template>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import {
  fetchOfficeList,
  resubmitOfficeApply,
} from "@/api/oa/purchaseMaterials";
import {mapGetters} from "vuex";

export default {
  mixins: [watermark],

  props: {
    inModal: { type: Boolean, default: false },
  },

  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      columns: [
        {
          title: "审批状态",
          dataIndex: "status",
          align: "center",
          scopedSlots: {customRender: "statusCol"},
        },
        {title: "申请人", dataIndex: "applicantName"},
        {title: "申请部门", dataIndex: "departmentName"},
        {title: "申请日期", dataIndex: "applyDate", align: "center"},
        {title: "创建时间", dataIndex: "createAt", align: "center"},
        {
          title: "操作",
          align: "center",
          width: 120,
          scopedSlots: {customRender: "actionCol"},
        },
      ],
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("taskReviewStatus");
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    getStatusName(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return statusValue;
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.name : statusValue;
    },

    getStatusColor(statusValue) {
      if (!this.statusList || !Array.isArray(this.statusList)) return statusValue;
      const status = this.statusList.find(item => item.value === statusValue);
      return status ? status.icon : 'geekblue';
    },
    getList() {
      const {current, pageSize, form} = this;
      this.loading = true;
      fetchOfficeList({
        pageNum: current,
        pageSize,
        ...form,
      })
          .then((res) => {
            this.loading = false;
            if (Array.isArray(res.list)) {
              this.list = res.list;
              this.total = res.totalSize;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },

    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },

    viewDetail(record) {
      this.$emit("detail", record);
    },

    resubmit(text) {
      this.$confirm({
        title: "重新发起确认",
        content: `确认重新发起该采购申请吗？`,
        onOk: () => {
          resubmitOfficeApply({id: text.id}).then(() => {
            this.$message.success("已重新发起");
            this.getList();
          });
        },
      });
    },
  },
};
</script>
